import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/billing/carriers/:carrierId/sources/:sourceId/errors",
		component: lazy(() => import("./PaymentMethodErrorsPage")),
	},
]);
